import { useState } from "react";
import {
  ChevronUpDownIcon,
  ChevronUpIcon,
  ChevronDownIcon,
} from "@heroicons/react/20/solid";

export default function Accordion({ title, children, sortDirection, onSort }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const getSortIcon = () => {
    switch (sortDirection) {
      case "asc":
        return <ChevronUpIcon className="h-5 w-5" />;
      case "desc":
        return <ChevronDownIcon className="h-5 w-5" />;
      default:
        return <ChevronUpDownIcon className="h-5 w-5" />;
    }
  };

  return (
    <div className="border border-gray-200 rounded-sm mb-2">
      <div className="flex justify-between items-center w-full px-4 py-2 text-left font-medium text-gray-900 bg-gray-100 border-b border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500">
        <button onClick={toggleAccordion} className="flex-grow text-left">
          {title}
        </button>
        <button onClick={onSort} className="ml-2 flex items-center">
          <span className=" text-sm text-gray-600">Sort</span>
          {getSortIcon()}
        </button>
      </div>
      {isOpen && <div className="p-4">{children}</div>}
    </div>
  );
}
